// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getSelectedRowsV2,
  DisplayWarningMessage, // eslint-disable-line no-unused-vars
  updatedTableDataForPreferenceV2,
  callAPIHelperV2,
  getClonedDefaultSettingsV2,
  resetTableDataV2,
  FxBreadcrumbs, // eslint-disable-line no-unused-vars
  callFxgApi,
} from 'axp-fx-common';
import { manageFxAccountTableProp } from './manageFxAccountInitData';
import { apiPaths } from '../../../constants/paths';
import { fxAccountBreadcrumbs } from '../../../constants/breadcrumbs';
import {
  API_SUCCESS_CD,
  CERT_ERROR_CD,
  PROD_ERROR_CD,
} from '../../../constants/apiCodes';
// eslint-disable-next-line no-unused-vars
import EnhancedDataTableWrapper from '../../Common/EnhancedDataTableWrapper';

const defaultTableSettings = getClonedDefaultSettingsV2(
  manageFxAccountTableProp
);

const ManageFxAccountDirectory = ({ setStepNo, setSelectedFxAccount }) => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [errorData, setErrorData] = useState([]);
  const [tableData, setTableData] = useState(manageFxAccountTableProp);

  const fetchData = async () => {
    setErrorData([]);
    let newRows = { totalRows: 0, data: [] };
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.getFxAccounts}`,
      'GET',
      ''
    );
    /* istanbul ignore else */
    if (!hasErrors) {
      if (response?.respCd === API_SUCCESS_CD && response.data?.length > 0) {
        const rowData = [];
        response.data.forEach((row) => {
          const rowMap = row;
          rowMap.showActions = row.status === 'Active'
            && row.hasBasicAuthProtocol
            && row.managePasswordInd === 'Y';
          rowMap.rowId = `${row.fxAccountId}_${row.environment}`;
          rowData.push(rowMap);
        });

        newRows = {
          totalRows: rowData.length,
          data: rowData,
        };
      }

      if ([CERT_ERROR_CD, PROD_ERROR_CD].includes(response?.respCd)) {
        setErrorData([response?.respMsg]);
      }
    }
    return { newRows, hasErrors };
  };

  const loadTableData = useCallback(async (updatedTableData) => {
    const { newRows, hasErrors } = await fetchData(updatedTableData);
    callAPIHelperV2(updatedTableData, newRows, setTableData, hasErrors);
  }, []); // fetchData is stable

  useEffect(() => {
    if (loginData?.userDetail?.emailAddress) {
    updatedTableDataForPreferenceV2(tableData, loginData);
    resetTableDataV2(tableData);
    loadTableData(tableData);
    }
  }, [loadTableData, loginData]); // tableData is mutable

  const onActionItemClick = (actionId) => {
    const selectedRow = getSelectedRowsV2(tableData)?.[0];
    if (!selectedRow) return;
    setSelectedFxAccount(selectedRow);
    if (actionId === 'update_password') {
      setStepNo(2);
    }
  };

  return (
    <>
      <FxBreadcrumbs breadcrumbItems={fxAccountBreadcrumbs} />

      {errorData?.length > 0 && (
        <DisplayWarningMessage messageDataList={errorData} />
      )}

      <EnhancedDataTableWrapper
        tableData={tableData}
        setTableData={setTableData}
        fetchTableData={fetchData}
        onItemActionClick={onActionItemClick}
        defaultTableSettings={defaultTableSettings}
      />
    </>
  );
};

ManageFxAccountDirectory.propTypes = {
  setStepNo: PropTypes.func.isRequired,
  selectedFxAccount: PropTypes.shape({}),
  setSelectedFxAccount: PropTypes.func.isRequired,
};

ManageFxAccountDirectory.displayName = 'ManageFxAccountDirectory';

export default ManageFxAccountDirectory;
